import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Event from './event'
import Container from 'components/program-marketing/container'

const useStyles = makeStyles(theme => ({
  title: {
    color: theme.palette.background.dark,
  },
}))

const ScheduleSection = ({ events, eventDates }) => {
  const classes = useStyles()
  return (
    <Container>
      <Box mb={2}>
        <Typography variant="h3" className={classes.title}>
          Schedule
        </Typography>
      </Box>
      <Box mb={1}>
        <Typography variant="h2">
          {events.length} Events, {eventDates.dates}*
        </Typography>
      </Box>
      <Box mb={5}>
        <Typography variant="body1">
          *Event schedule subject to change.
        </Typography>
      </Box>
      {events.map(event => (
        <Event key={event.id} event={event} />
      ))}
    </Container>
  )
}

export default ScheduleSection
